// extracted by mini-css-extract-plugin
export default {"footer-info-title":"Footer_footer-info-title__7BPlJ","footer-info-text":"Footer_footer-info-text__FR9ZG"};